<template>
  <div class="navigation">
    <div class="choose-manager" v-if="currentMenu === `manager`">
      <v-card>
        <v-card-title>
          <div class="headline">
            Qui êtes-vous ?
          </div>
        </v-card-title>
        <v-list two-line>
          <p class="text-xs-left pl-3" v-if="managers.length === 0 && isUpdating"><em>Chargement...</em></p>
          <p class="text-xs-left pl-3" v-else-if="managers.length === 0 && !isUpdating"><em>Pas de manager autorisé sur cette tablette</em></p>
          <span v-for="manager in managers" v-on:click="chooseManager(manager)" :key="manager.id">
            <v-divider></v-divider>
            <v-list-tile>
              <v-list-tile-avatar>
                <v-icon>person</v-icon>
              </v-list-tile-avatar>
              <v-list-tile-content>
                <v-list-tile-title>{{ manager.firstname }} {{ manager.lastname }}</v-list-tile-title>
                <v-list-tile-sub-title>{{ manager.email }}</v-list-tile-sub-title>
              </v-list-tile-content>
              <v-list-tile-action>
                <v-btn icon ripple>
                  <v-icon class="grey--text text--lighten-1">play_circle_filled</v-icon>
                </v-btn>
              </v-list-tile-action>
            </v-list-tile>
          </span>
        </v-list>
      </v-card>
    </div>

    <div class="choose-survey" v-if="currentMenu === `survey`">
      <div v-if="currentManager">
        <v-card>
          <v-card-title class="text-xs-left">
            <div>
              <v-btn class="ml-0 mb-4" v-on:click.native="goBackToManagerChoice">&larr; Précédent</v-btn>
              <p class="mb-0" v-if="currentManager.surveyStarts">Veuillez choisir une enquête dans la liste ci-dessous</p>
              <p v-else>Pas d'enquête ouverte pour cet utilisateur</p>
            </div>
          </v-card-title>
          <v-list two-line v-if="currentManager.surveyStarts">
            <span v-for="surveyStart in currentManager.surveyStarts" v-on:click="chooseSurveyStart(surveyStart)" :key="surveyStart.id">
              <v-divider></v-divider>
              <v-list-tile>
                <v-list-tile-avatar>
                  <v-icon>assignment</v-icon>
                </v-list-tile-avatar>
                <v-list-tile-content>
                  <v-list-tile-title>{{ surveyStart.survey.name }}</v-list-tile-title>
                  <v-list-tile-sub-title>Enquête démarrée le {{ moment(surveyStart.createdAt).format('DD/MM/YYYY') }}</v-list-tile-sub-title>
                </v-list-tile-content>
                <v-list-tile-action>
                  <v-btn icon ripple>
                    <v-icon class="grey--text text--lighten-1">play_circle_filled</v-icon>
                  </v-btn>
                </v-list-tile-action>
              </v-list-tile>
            </span>
          </v-list>
        </v-card>
      </div>
      <div v-else>
        <v-card>
          <v-card-title class="text-xs-left">
            <div>
              <v-btn class="ml-0 mb-4" to="/">&larr; Précédent</v-btn>
              <p>Aucun manager selectionné</p>
            </div>
          </v-card-title>
        </v-card>
      </div>
    </div>

    <div class="choose-participant" v-if="currentMenu === `participant`">
      <div v-if="currentSurveyStart">
        <v-card>
          <v-card-title class="text-xs-left pb-0">
            <v-btn class="ml-0 mb-4" v-on:click.native="goBackToSurveyChoice">&larr; Précédent</v-btn>
            <p class="mb-0 mt-2 text-xs-center subheading" style="width:100%;"><strong>{{ currentManager.firstname }} {{ currentManager.lastname }}</strong>, qui souhaitez-vous faire répondre ?</p>
          </v-card-title>

          <div class="text-xs-center mt-3 mb-2">
            <v-menu offset-y class="team-filter-menu">
              <v-btn class="pa-1 pr-2" slot="activator" v-if="Object.keys(currentPossibleNodes).length > 2">Afficher les participants de : <em>{{ currentPossibleNodes[teamFilter] }}</em> <v-icon>keyboard_arrow_down</v-icon></v-btn>
              <v-list>
                <span v-for="(label, node) in currentPossibleNodes" :key="node" class="team-filter-menu-item">
                  <v-list-tile  @click="" :disabled="teamFilter === node" v-on:click.native="teamFilter = node">
                    <v-list-tile-title >{{ label }}</v-list-tile-title>
                  </v-list-tile>
                  <v-divider></v-divider>
                </span>
              </v-list>
            </v-menu>
          </div>

          <v-list two-line>
            <template v-for="participant in currentParticipants" v-if="participant.employee.id !== currentManager.id">
              <v-divider></v-divider>
              <v-list-tile v-on:click.native="chooseParticipant(participant)" :disabled="participant.hasAnswered || participant.isDone">
                <v-list-tile-avatar>
                  <v-icon>person</v-icon>
                </v-list-tile-avatar>
                <v-list-tile-content>
                  <v-list-tile-title>
                    <span>{{ participant.employee.firstname }} {{ participant.employee.lastname }}</span>
                  </v-list-tile-title>
                  <v-list-tile-sub-title>
                    <span>Membre de l'équipe: <em>{{ participant.node.label }}</em></span>
                    <span v-if="participant.employee.id === currentManager.id">Manager de: <em>{{ participant.node.label }}</em></span>
                    <span v-else-if="false && (participant.employee.email || participant.employee.phone)">Cet employé a reçu une invitation pour répondre</span>
                  </v-list-tile-sub-title>
                </v-list-tile-content>
                <v-list-tile-action>
                  <v-btn icon ripple>
                    <v-icon v-if="participant.hasAnswered || participant.isDone" class="green--text text--lighten-1">check</v-icon>
                    <v-icon v-else class="grey--text text--lighten-1">play_circle_filled</v-icon>
                  </v-btn>
                </v-list-tile-action>
              </v-list-tile>
            </template>

            <template v-for="(info, nodeId) in nextMergedParticipants" v-if="!onTheFly || info.nbLeft > 0">
              <v-divider></v-divider>
              <v-list-tile v-on:click.native="chooseNextMergedParticipant(nodeId)" :disabled="info.nbLeft === 0">
                <v-list-tile-avatar>
                  <v-icon >person</v-icon>
                </v-list-tile-avatar>
                <v-list-tile-content>
                  <v-list-tile-title>
                    <span>Membre de l'équipe: <em>{{ info.node.label  }}</em></span>
                  </v-list-tile-title>
                  <v-list-tile-sub-title>
                    {{ info.nbDone }}/{{ info.nbTotal }}
                  </v-list-tile-sub-title>
                </v-list-tile-content>
                <v-list-tile-action>
                  <v-btn icon ripple>
                    <v-icon v-if="info.nbLeft === 0" class="green--text text--lighten-1">check</v-icon>
                    <v-icon v-else class="grey--text text--lighten-1">play_circle_filled</v-icon>
                  </v-btn>
                </v-list-tile-action>
              </v-list-tile>
            </template>

            <template v-for="participant in additionnalParticipants">
              <v-divider></v-divider>
              <v-list-tile v-on:click.native="chooseParticipant(participant)">
                <v-list-tile-avatar>
                  <v-icon v-if="participant.isAdditionnal">person_add</v-icon>
                  <v-icon v-else>person</v-icon>
                </v-list-tile-avatar>
                <v-list-tile-content>
                  <v-list-tile-title>
                    <span>Membre de l'équipe: <em>{{ participant.node.label  }}</em></span>
                  </v-list-tile-title>
                  <v-list-tile-sub-title>
                    <span v-if="participant.node.nbEmployeesWOEmail === 0">
                      Participant supplémentaire
                    </span>
                    <span v-else-if="nextMergedParticipants[participant.node.id]">
                      {{ nextMergedParticipants[participant.node.id].nbDone }}/{{ nextMergedParticipants[participant.node.id].nbTotal }}
                    </span>
                  </v-list-tile-sub-title>
                </v-list-tile-content>
                <v-list-tile-action>
                  <v-btn icon ripple>
                    <v-icon class="grey--text text--lighten-1">play_circle_filled</v-icon>
                  </v-btn>
                </v-list-tile-action>
              </v-list-tile>
            </template>

          </v-list>
        </v-card>
      </div>
      <div v-else>
        <v-card>
          <v-card-title class="text-xs-left">
            <div>
              <v-btn class="ml-0 mb-4" to="/">&larr; Précédent</v-btn>
              <p>Aucune enquête selectionnée</p>
            </div>
          </v-card-title>
        </v-card>
      </div>
    </div>

  </div>
</template>

<script>
import { mapState } from 'vuex';
import moment from 'moment';
import _ from 'lodash';

export default {
  name: `navigation`,
  data () {
    return {
      teamFilter: `all`,
    };
  },
  props: [`currentMenu`],
  methods: {
    moment,
    goBackToManagerChoice () {
      this.$router.push(`/choose/manager`);
      this.currentManager     = null;
      this.currentSurveyStart = null;
    },
    goBackToSurveyChoice () {
      if (this.currentManager.surveyStarts && this.currentManager.surveyStarts.length === 1) {
        this.goBackToManagerChoice();
        return;
      }

      this.$router.push(`/choose/survey`);
    },
    chooseManager (manager) {
      this.currentManager = manager;
      if (manager.surveyStarts && manager.surveyStarts.length === 1) {
        const ss = manager.surveyStarts[0];
        this.chooseSurveyStart(ss);
        return;
      }
      this.$router.push(`/choose/survey`)
    },
    chooseSurveyStart (surveyStart) {
      this.currentSurveyStart = surveyStart;
      this.teamFilter         = `all`;
      // this.currentMenu        = `participant`;
      this.$router.push(`participant`);
    },
    chooseParticipant (participant) {
      if (!participant.isAdditionnal && (participant.hasAnswered || participant.isDone)) return;

      const survey = this.$store.state.weviewObject.surveys.find(su => su.id === this.currentSurveyStart.survey.id);
      if (participant.answerSlave) {
        if (!survey.questions.find(q => q.id === survey.slaveQuestions[0].id)) {
          survey.questions.push(...survey.slaveQuestions);
        }
      } else {
        if (survey.questions.find(q => q.id === survey.questions[0].id)) {
          survey.questions = survey.questions.filter(q => !survey.slaveQuestions.find(sq => sq.id === q.id));
        }
      }
      this.$store.commit(`SET_CURRENT_PARTICIPANT`, participant);
      this.$store.commit(`SET_CURRENT_SURVEY`, survey);
      this.$store.commit(`SET_CURRENT_MANAGER`, this.currentManager);
      this.$store.commit(`SET_CURRENT_SURVEYSTART`, this.currentSurveyStart);
      this.teamFilter = `all`;
      this.$router.push({ name: `Answer` });
    },
    chooseNextMergedParticipant (nodeId) {
      if (this.nextMergedParticipants[nodeId] && this.nextMergedParticipants[nodeId].nbLeft === 0) return;

      const participant = this.currentSurveyStart.participants.find(p => !p.isDone && !p.isAdditionnal && !p.hasAnswered && p.isMerged && p.node.id === nodeId);
      if (!participant) { return; }

      return this.chooseParticipant(participant);
    },
    updateCurrents () {
      if (this.currentManager) {
        const newManagerObj = this.managers.find(m => m.id === this.currentManager.id);
        this.currentManager = newManagerObj;

        if (this.currentSurveyStart) {
          if (!newManagerObj.surveyStarts) {
            // surveystart was finished/close remotly, go back
            this.goBackToSurveyChoice();
            return;
          }
          const newSurveyStartObj = newManagerObj.surveyStarts.find(ss => ss.id === this.currentSurveyStart.id);
          this.currentSurveyStart = newSurveyStartObj;
        }
      }
    },
  },

  computed: {
    additionnalParticipants () {
      const additionnalParticipants = [];
      if (this.onTheFly) {
        this.currentSurveyStart.participants.forEach(participant => {
          if (!additionnalParticipants.find(p => p.node.id === participant.node.id)
          && (!this.nextMergedParticipants[participant.node.id] || this.nextMergedParticipants[participant.node.id] && this.nextMergedParticipants[participant.node.id].nbLeft === 0)) {
            const additionnalParticipant = _.cloneDeep(participant);
            additionnalParticipant.isAdditionnal = true;
            additionnalParticipant.isFly = true;
            additionnalParticipants.push(additionnalParticipant);
          }
        });
      }

      return additionnalParticipants.filter(p => p.node.id === this.teamFilter || this.teamFilter === `all`);
    },
    currentParticipants () {
      let currentParticipants =  this.currentSurveyStart.participants.filter(p => p.employee);

      currentParticipants.sort((a,b) => {
        let scoreA = 0;
        let scoreB = 0;
        if (a.isDone || a.hasAnswered) scoreA += 400;
        if (b.isDone || b.hasAnswered) scoreB += 400;
        if (a.employee) scoreA += 150;
        if (b.employee) scoreB += 150;
        if (a.employee && b.employee && a.employee.firstname.localeCompare(b.employee.firstname) > 0) scoreA += 50;
        else scoreB += 50;

        return scoreA - scoreB;
      });

      // filter to only display selected teams:
      return currentParticipants.filter(p => p.node.id === this.teamFilter || this.teamFilter === `all`);
    },
    nextMergedParticipants () {
      const nextMergedParticipants = {};

      this.currentSurveyStart.participants.forEach(participant => {
        // if (!participant.isMerged && participant.employee) { return; }
        if (participant.employee && !participant.isAdditionnal) { return; }
        if (nextMergedParticipants[participant.node.id]) {

          nextMergedParticipants[participant.node.id].nbDone += (participant.isDone || participant.hasAnswered) ? 1 : 0;
          nextMergedParticipants[participant.node.id].nbLeft += (participant.isDone || participant.hasAnswered) ? 0 : 1;
          nextMergedParticipants[participant.node.id].nbTotal += (!participant.isFly) ? 1 : 0;
        } else {
          nextMergedParticipants[participant.node.id] = {
            nbDone : (participant.isDone || participant.hasAnswered) ? 1 : 0,
            nbLeft : (participant.isDone || participant.hasAnswered) ? 0 : 1,
            nbTotal : (!participant.isFly) ? 1 : 0,
            node   : participant.node,
          }
        }
      });

      // filter to only display selected teams :
      Object.keys(nextMergedParticipants).forEach(nodeId => {
        if (this.teamFilter !== `all` && nodeId !== this.teamFilter) {
          Reflect.deleteProperty(nextMergedParticipants, nodeId);
        }
      })

      return nextMergedParticipants;
    },
    currentPossibleNodes () {
      const nodes = { all : `Toutes les équipes` };
      this.currentSurveyStart.participants.forEach(participant => {
        if (!nodes[participant.node.id]) {
          nodes[participant.node.id] = participant.node.label;
        }
      });

      return nodes;
    },
    currentManager : {
      get () { return this.$store.state.navigation.currentManager; },
      set (newVal) { this.$store.commit(`NAV_SET_CURRENT_MANAGER`, newVal); },
    },
    currentSurveyStart: {
      get () { return this.$store.state.navigation.currentSurveyStart; },
      set (surveyStart) { this.$store.commit(`NAV_SET_CURRENT_SURVEYSTART`, surveyStart); },
    },
    ...mapState([`isUpdating`]),
    ...mapState({
      managers (state) {
        if (state && state.weviewObject) {
          return state.weviewObject.managers;
        }
        return [];
      },
      onTheFly (state) {
        if (state && state.weviewObject && state.weviewObject.settings) {
          return state.weviewObject.settings.onTheFly || false;
        }

        return false;
      },
    }),
  },

  watch: {
    managers: {
      deep: true,
      handler () {
        this.updateCurrents();
      },
    },
  },

};
</script>

<style>
  .navigation .breadcrumbs {
    justify-content: flex-start;
  }
  .navigation .stepper__label {
    text-align: center;
  }
  .team-filter-menu-item:last-child hr {
    display : none;
    opacity : 1;
  }
  .navigation .avatar .icon {
    height: 25px;
  }
</style>



// WEBPACK FOOTER //
// Navigation.vue?3f350bf6